import * as React from 'react';
import { Skeleton } from '@bytebrand/fe-ui-core-autobahn/ui';
import _get from 'lodash/get';
import appConfig from '../../../../config/app.config';
import { SERVICE_UNAVAILABLE, isCloudflareChallenge } from '../../../framework/constants/app';
import styles from './LoadingPage.styl';
class LoadingPage extends React.PureComponent {
    componentDidMount() {
        const { error } = this.props;
        if (!error)
            return;
        if (_get(error, 'response.status') === SERVICE_UNAVAILABLE || isCloudflareChallenge(_get(error, 'response'))) {
            const { location: { pathname, search } } = window;
            window.location.replace(`${appConfig.redirectUrl.serviceUnavailable}${pathname}${encodeURIComponent(search)}`);
        }
    }
    render() {
        const { isLoading } = this.props;
        return (React.createElement("div", { className: styles.loadingPage }, isLoading && React.createElement(Skeleton, { animation: 'wave', variant: 'rectangular', height: '100%' })));
    }
}
export default LoadingPage;
